'use strict';

var isControllingVariants = require('../../render/utils/is-controlling-variants.cjs');
var isVariantLabel = require('../../render/utils/is-variant-label.cjs');

function getCurrentTreeVariants(props, context) {
    if (isControllingVariants.isControllingVariants(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || isVariantLabel.isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel.isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

exports.getCurrentTreeVariants = getCurrentTreeVariants;
//# sourceMappingURL=utils.cjs.map
